import {
    createField,
    updateField
} from '../../actions';
import {
    EVENT_STEP_VALIDATE
} from '../../helpers/consts';

export class UsernameField {
    constructor(options) {
        this.store = options.store;
        this.state = this.store.getState();
        this.$context = options.$context;
        this.id = options.id;
        this.label = options.label;
        this.placeholder = options.placeholder !== undefined ? options.placeholder : '';
        this.required = options.required !== undefined ? options.required : true;
        this.readOnly = options.readOnly !== undefined ? options.readOnly : false;
        this.stepId = options.stepId
        const fieldState = this.state.formFields.find(field => field.id === this.id);
        this.value = (fieldState && fieldState.value) ? fieldState.value : '';
        this.isValid = (fieldState && fieldState.valid) ? fieldState.valid : false;
        this.$el = this.createFieldElement();

        if (this.value !== '' || !this.required) {
            this.validate();
        }
    }

    createFieldElement() { // eslint-disable-line class-methods-use-this
        let debounceTimeout;
        const $field = document.createElement('div');
        const $fieldLabel = document.createElement('label');
        this.$fieldInput = document.createElement('input');
        this.$fieldMessage = document.createElement('span');

        this.$fieldInput.type = 'text';
        this.$fieldInput.id = this.id;
        this.$fieldInput.required = this.required;
        this.$fieldInput.readOnly = this.readOnly;
        if (this.readOnly) this.$fieldInput.tabIndex = -1;
        this.$fieldInput.placeholder = this.placeholder;
        this.$fieldInput.value = this.value;
        $fieldLabel.setAttribute('for', this.id);
        $fieldLabel.innerHTML = this.label;

        $field.classList.add('field', 'form-group', 'field--text')
        $fieldLabel.classList.add('field-label');
        this.$fieldInput.classList.add('field-input', 'form-control', 'field-input--text');
        this.$fieldMessage.classList.add('invalid-feedback');
        this.$fieldMessage.setAttribute('role', 'alert');

        $field.appendChild($fieldLabel);
        $field.appendChild(this.$fieldInput);
        $field.appendChild(this.$fieldMessage);

        this.store.dispatch(createField(this.id, this.label, this.stepId));
        this.$fieldInput.addEventListener('blur', this.validate.bind(this));
        this.$fieldInput.addEventListener('input', () => {
            clearTimeout(debounceTimeout);
            debounceTimeout = setTimeout(this.validate.bind(this), 100);
        });

        return $field;
    }

    setValue(value) {
        this.$fieldInput.value = value;
        this.validate(value === '');
    }

    validate(_hideMessage = false) {
        const hideMessage = typeof _hideMessage !== 'boolean' ? false : _hideMessage;

        this.$fieldInput.classList.remove('is-valid');
        this.isValid = false;
        this.$fieldMessage.classList.toggle('visually-hidden', hideMessage);

        if(this.isValid) {
            this.store.dispatch(updateField(this.id, this.$fieldInput.value, this.isValid, this.label));
        }

        if (! this.readOnly) {
            this.$context.dispatchEvent(EVENT_STEP_VALIDATE);
        }
    }

    valid() {
        return this.isValid;
    }

    render() {
        return this.$el;
    }
}

export default UsernameField;
